import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as CheckIcon } from 'icons/Check.svg';

import Status from './Status';

class TrafficLabel extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <Status upproved={this.props.isCorrectorApproved}>
          <CheckIcon /> Корректор
        </Status>

        <Status upproved={this.props.isEditorApproved}>
          <CheckIcon /> Редактор
        </Status>
      </React.Fragment>
    );
  }
}

TrafficLabel.propTypes = {
  isEditorApproved: PropTypes.bool,
  isCorrectorApproved: PropTypes.bool,
};

TrafficLabel.defaultProps = {
  isEditorApproved: false,
  isCorrectorApproved: false,
};

export default TrafficLabel;
